// src/config.ts

function getEnv(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`❌ Environment variable "${name}" is missing.`);
  }
  return value;
}

function getOptionalPositiveIntEnv(name: string, fallback: number): number {
  const rawValue = process.env[name];
  if (!rawValue) {
    return fallback;
  }

  const parsedValue = Number.parseInt(rawValue, 10);
  if (Number.isNaN(parsedValue) || parsedValue <= 0) {
    return fallback;
  }
  return parsedValue;
}

const environment = getEnv("REACT_APP_ENVIRONMENT");

const apiUrl = environment === "production"
  ? getEnv("REACT_APP_API_URL_PROD")
  : getEnv("REACT_APP_API_URL_DEV");

const logLevel = environment === "production" ? "error" : "debug";
const underMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === "true";

const clientId = getEnv("REACT_APP_CLIENT_ID");
const authority = getEnv("REACT_APP_AUTHORITY");

const redirectUri = getEnv(
  environment === "production"
    ? "REACT_APP_REDIRECT_URI_PROD"
    : "REACT_APP_REDIRECT_URI_DEV"
);

const loginRequestScope = getEnv("REACT_APP_LOGIN_REQUEST_SCOPE");
const hmiEventTextMaxLength = getOptionalPositiveIntEnv("REACT_APP_HMI_EVENT_TEXT_MAX_LENGTH", 500);

export const config = {
  environment,
  apiUrl,
  logLevel,
  underMaintenance,
  clientId,
  authority,
  redirectUri,
  loginRequestScope,
  hmiEventTextMaxLength,
};
